import script from "./DetailRelatedBlogs.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailRelatedBlogs.vue?vue&type=script&setup=true&lang=js"

import "./DetailRelatedBlogs.vue?vue&type=style&index=0&id=1f06f2f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f06f2f2"]])

export default __exports__